import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePaymentStatusModalStore } from '@/store/usePaymentStatusModalStore';
import { Popup } from '@/components/UI/Popup/Popup';
import { AdPageTestIds } from '@/__e2e__/testIds/ad-page';

export const SuccessPaymentStatusModal = () => {
  const [isOpen, setIsOpen, paymentData] = usePaymentStatusModalStore(state => [
    state.isSuccessPaymentModalOpen,
    state.setIsSuccessPaymentModalOpen,
    state.successPaymentModalData,
  ]);
  const { title, subtitle, iconName } = paymentData || {};
  const { t } = useTranslation();

  function onClose() {
    setIsOpen(false);
  }

  return (
    <Popup
      dataTestId={AdPageTestIds.popup.success}
      isOpen={isOpen}
      close={onClose}
      title={title}
      capitalizeTitle
      description={subtitle}
      icon={`${iconName}.svg`}
      actions={{
        left: { text: t('common.ok'), onClick: onClose },
      }}
    />
  );
};
